<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'SimpleLayout'
}
</script>

<style lang="css" scoped>
  @import '../assets/css/normalize.css';
  @import '../assets/css/main.css';
  @import '../assets/css/tailwind.min.css';
  @import '../assets/css/styles.css';
  @import url('https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap');
  @import '../assets/css/fontello.css';
</style>
